import { ExpertiseValues } from 'enums/Expertise';
import { FormationValues } from 'enums/Formation';
import { StudyLevelValues } from 'enums/StudyLevels';
import MentorForm from 'types/MentorForm';

export type State = Required<
  Pick<
    MentorForm,
    | 'jobSearch'
    | 'careerPlan'
    | 'studies'
    | 'entrepreneurship'
    | 'consideration'
    | 'hobby'
    | 'heardAboutMentorship'
    | 'heardAboutMentorshipText'
    | 'expectations'
    | 'sharingEmail'
    | 'sharingPhone'
  >
> & {
  expertises: ExpertiseValues[];
  formations: FormationValues[];
  diploma: StudyLevelValues[];
  wantedMentorships: number;
};

export type Errors = {
  expertises: boolean;
  general: boolean;
  badRequest: boolean;
  permissions: boolean;
  expectations: boolean;
};

export const initialErrors: Errors = {
  expertises: false,
  general: false,
  badRequest: false,
  permissions: false,
  expectations: false,
};
